<template>
    <div class="loading"> 
        <div v-if="_progress.is" class="content">
            <p>{{_progress.title}}</p>
            <progress v-if="_progress.type === 1" id="progress" :value="_progress.value" min="0" max="100"></progress>
            <progress v-if="_progress.type === 2" id="progress_price" :value="_progress.value" min="0" max="100"></progress>
            <progress v-if="_progress.type === 3" id="progress_ins" :value="_progress.value" min="0" max="100"></progress>            
        </div>
        <div v-else class="content">
            <p>다음 작업을 위해 정리중입니다...</p>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'ProgressOverlay',
    components: {
    },
    computed: {
        ...mapState('reportStore', ['report', '_progress']),
    },    
}
</script>
<style scoped>
.loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background-color: rgba(0,0,0,0.25); */
    z-index: 100000;
}


.content{
    left: 50%;
    top: 50%;
    position: absolute;
}
.loading p{
    position: relative;
    font-size: 14px;
    color: #1A1B19;
    font-weight: bold;
}
#progress {
    appearance: none;
    position: relative;
}
#progress::-webkit-progress-bar {
    background:#f0f0f0;
    border-radius:10px;
    box-shadow: inset 3px 3px 10px #ccc;
}
#progress::-webkit-progress-value {
    border-radius:10px;
    background: #1D976C;
    background: -webkit-linear-gradient(to right, #93F9B9, #1D976C);
    background: linear-gradient(to right, #93F9B9, #1D976C);
}   

#progress_price {
    appearance: none;
    position: relative;
}
#progress_price::-webkit-progress-bar {
    background:#f0f0f0;
    border-radius:10px;
    box-shadow: inset 3px 3px 10px #ccc;
}
#progress_price::-webkit-progress-value {
    border-radius:10px;
    background: #251D97;
    background: -webkit-linear-gradient(to right, #9593F9, #251D97);
    background: linear-gradient(to right, #9593F9, #251D97);
} 

#progress_ins {
    appearance: none;
    position: relative;
}
#progress_ins::-webkit-progress-bar {
    background:#f0f0f0;
    border-radius:10px;
    box-shadow: inset 3px 3px 10px #ccc;
}
#progress_ins::-webkit-progress-value {
    border-radius:10px;
    background: #81971D;
    background: -webkit-linear-gradient(to right, #D5F993, #81971D);
    background: linear-gradient(to right, #D5F993, #81971D);
} 
</style>